import { Object3D, Vector3 } from 'three';
import { IV3D } from '@/Interfaces/v3d';
import { getLineMesh } from '@/Engine/Primitives/LineMesh';
import { lineSegmentLength } from '@/Constants/3dConfig';

declare let v3d: IV3D;


export class LineDotted {
    model: Object3D;

    constructor(start: Vector3, end: Vector3, option = 'dotted', black = false) {
        this.model = new v3d.Group();



        const length = start.distanceTo(end);
        const segmentNum = Math.floor(length / lineSegmentLength);

        switch (option) {
            case 'dotted':
                for (let i = 0; i <= segmentNum; i++) {
                    if (i % 2) {
                        const line = getLineMesh(black);

                        if (i * lineSegmentLength + lineSegmentLength > length) {
                            line.scale.y = length - i * lineSegmentLength;
                        }
                        line.position.set(0, 0, i * lineSegmentLength - (lineSegmentLength - line.scale.y) / 2);
                        this.model.add(line);
                    }
                }
                break;
            default:
                break;
        }

        this.model.position.copy(start);
        this.model.lookAt(end);

    }
}
